import { render, staticRenderFns } from "./post-comment.vue?vue&type=template&id=22cd996f&"
import script from "./post-comment.vue?vue&type=script&lang=js&"
export * from "./post-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports